import React from 'react'

const DataPolicyDE = () => {
    return (
        <>
            <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
            <style
                type="text/css"
                dangerouslySetInnerHTML={{
                    __html: '@import url(https://themes.googleusercontent.com/fonts/css?kit=dpiI8CyVsrzWsJLBFKehGpLhv3qFjX7dUn1mYxfCXhI);.lst-kix_kp6udrh6klz6-8>li:before{content:"-  "}.lst-kix_kp6udrh6klz6-7>li:before{content:"-  "}ul.lst-kix_6euado2a7fnu-7{list-style-type:none}.lst-kix_j25jahnvxxq5-3>li:before{content:"-  "}.lst-kix_j25jahnvxxq5-4>li:before{content:"-  "}ul.lst-kix_6euado2a7fnu-6{list-style-type:none}ul.lst-kix_6euado2a7fnu-8{list-style-type:none}ul.lst-kix_j25jahnvxxq5-5{list-style-type:none}ul.lst-kix_j25jahnvxxq5-6{list-style-type:none}.lst-kix_j25jahnvxxq5-7>li:before{content:"-  "}.lst-kix_6euado2a7fnu-5>li:before{content:"\\0025a0   "}ul.lst-kix_j25jahnvxxq5-7{list-style-type:none}ul.lst-kix_j25jahnvxxq5-8{list-style-type:none}ul.lst-kix_j25jahnvxxq5-1{list-style-type:none}ul.lst-kix_j25jahnvxxq5-2{list-style-type:none}.lst-kix_j25jahnvxxq5-5>li:before{content:"-  "}.lst-kix_j25jahnvxxq5-6>li:before{content:"-  "}.lst-kix_6euado2a7fnu-6>li:before{content:"\\0025cf   "}.lst-kix_6euado2a7fnu-7>li:before{content:"\\0025cb   "}ul.lst-kix_j25jahnvxxq5-3{list-style-type:none}ul.lst-kix_j25jahnvxxq5-4{list-style-type:none}.lst-kix_6euado2a7fnu-8>li:before{content:"\\0025a0   "}ul.lst-kix_j25jahnvxxq5-0{list-style-type:none}ul.lst-kix_kp6udrh6klz6-6{list-style-type:none}.lst-kix_j25jahnvxxq5-8>li:before{content:"-  "}ul.lst-kix_kp6udrh6klz6-7{list-style-type:none}ul.lst-kix_6euado2a7fnu-1{list-style-type:none}ul.lst-kix_kp6udrh6klz6-4{list-style-type:none}ul.lst-kix_6euado2a7fnu-0{list-style-type:none}ul.lst-kix_kp6udrh6klz6-5{list-style-type:none}ul.lst-kix_6euado2a7fnu-3{list-style-type:none}ul.lst-kix_6euado2a7fnu-2{list-style-type:none}ul.lst-kix_6euado2a7fnu-5{list-style-type:none}ul.lst-kix_kp6udrh6klz6-8{list-style-type:none}ul.lst-kix_6euado2a7fnu-4{list-style-type:none}ul.lst-kix_kp6udrh6klz6-2{list-style-type:none}ul.lst-kix_kp6udrh6klz6-3{list-style-type:none}ul.lst-kix_kp6udrh6klz6-0{list-style-type:none}ul.lst-kix_kp6udrh6klz6-1{list-style-type:none}.lst-kix_9vc03qu28znz-0>li:before{content:"\\0025cf   "}.lst-kix_9vc03qu28znz-3>li:before{content:"\\0025cf   "}.lst-kix_9vc03qu28znz-1>li:before{content:"\\0025cb   "}.lst-kix_9vc03qu28znz-5>li:before{content:"\\0025a0   "}.lst-kix_9vc03qu28znz-2>li:before{content:"\\0025a0   "}.lst-kix_9vc03qu28znz-6>li:before{content:"\\0025cf   "}.lst-kix_j25jahnvxxq5-0>li:before{content:"-  "}.lst-kix_6euado2a7fnu-4>li:before{content:"\\0025cb   "}.lst-kix_j25jahnvxxq5-1>li:before{content:"-  "}.lst-kix_j25jahnvxxq5-2>li:before{content:"-  "}.lst-kix_6euado2a7fnu-2>li:before{content:"\\0025a0   "}.lst-kix_6euado2a7fnu-3>li:before{content:"\\0025cf   "}.lst-kix_9vc03qu28znz-4>li:before{content:"\\0025cb   "}.lst-kix_kp6udrh6klz6-0>li:before{content:"-  "}.lst-kix_6euado2a7fnu-0>li:before{content:"\\0025cf   "}.lst-kix_6euado2a7fnu-1>li:before{content:"\\0025cb   "}.lst-kix_kp6udrh6klz6-3>li:before{content:"-  "}.lst-kix_kp6udrh6klz6-4>li:before{content:"-  "}.lst-kix_9vc03qu28znz-7>li:before{content:"\\0025cb   "}.lst-kix_kp6udrh6klz6-6>li:before{content:"-  "}li.li-bullet-0:before{margin-left:-18pt;white-space:nowrap;display:inline-block;min-width:18pt}.lst-kix_kp6udrh6klz6-5>li:before{content:"-  "}.lst-kix_9vc03qu28znz-8>li:before{content:"\\0025a0   "}ul.lst-kix_9vc03qu28znz-7{list-style-type:none}ul.lst-kix_9vc03qu28znz-6{list-style-type:none}ul.lst-kix_9vc03qu28znz-8{list-style-type:none}ul.lst-kix_9vc03qu28znz-3{list-style-type:none}ul.lst-kix_9vc03qu28znz-2{list-style-type:none}ul.lst-kix_9vc03qu28znz-5{list-style-type:none}ul.lst-kix_9vc03qu28znz-4{list-style-type:none}.lst-kix_kp6udrh6klz6-2>li:before{content:"-  "}.lst-kix_kp6udrh6klz6-1>li:before{content:"-  "}ul.lst-kix_9vc03qu28znz-1{list-style-type:none}ul.lst-kix_9vc03qu28znz-0{list-style-type:none}ol{margin:0;padding:0}table td,table th{padding:0}.c2{margin-left:36pt;padding-top:0pt;padding-left:0pt;padding-bottom:0pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:left}.c0{background-color:#ffffff;color:#343535;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Roboto";font-style:normal}.c18{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}.c9{background-color:#ffffff;-webkit-text-decoration-skip:none;color:#1155cc;text-decoration:underline;text-decoration-skip-ink:none;font-size:12pt}.c22{padding-top:0pt;padding-bottom:0pt;line-height:1.15;orphans:2;widows:2;text-align:left}.c16{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:justify}.c8{padding-top:0pt;padding-bottom:0pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:left}.c4{background-color:#ffffff;font-size:12pt;font-family:"Roboto";color:#343535;font-weight:400}.c3{background-color:#ffffff;font-size:12pt;font-family:"Roboto";color:#343535;font-weight:700}.c15{background-color:#ffffff;color:#343535;font-weight:400;font-size:11.5pt;font-family:"Albert Sans"}.c19{color:#000000;font-weight:400;font-size:12pt;font-family:"Albert Sans"}.c20{color:#000000;font-weight:400;font-size:26pt;font-family:"Albert Sans"}.c21{color:#000000;font-weight:700;font-size:12pt;font-family:"Albert Sans"}.c17{color:#000000;font-weight:400;font-size:11pt;font-family:"Albert Sans"}.c7{text-decoration:none;vertical-align:baseline;font-style:normal}.c12{background-color:#ffffff;font-size:12pt;color:#0a0a0a}.c1{background-color:#ffffff;max-width:451.4pt;padding:72pt 72pt 72pt 72pt}.c13{color:inherit;text-decoration:inherit}.c14{font-weight:400;font-family:"Roboto"}.c6{padding:0;margin:0}.c5{font-style:italic}.c11{margin-left:36pt}.c10{height:11pt}.c23{font-size:12pt}.title{padding-top:0pt;color:#000000;font-size:26pt;padding-bottom:3pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:0pt;color:#666666;font-size:15pt;padding-bottom:16pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Albert Sans"}p{margin:0;color:#000000;font-size:11pt;font-family:"Albert Sans"}h1{padding-top:20pt;color:#000000;font-size:20pt;padding-bottom:6pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-size:16pt;padding-bottom:6pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:16pt;color:#434343;font-size:14pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:14pt;color:#666666;font-size:12pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}'
                }}
            />
            <p className="c16">
                <span className="c19 c7">Datenschutzrichtlinie</span>
            </p>
            <p className="c16">
                <span className="c7 c19">Stand: Oktober 2023</span>
            </p>
            <p className="c16">
                <span className="c23">
                    Um unsere Parkplätze für dich buchbar machen zu können, brauchen wir auch ein paar deiner Daten.
                    Dabei ist uns der
                </span>
                <span className="c0">&nbsp;Schutz deiner Privatsphäre sehr wichtig!</span>
            </p>
            <p className="c16">
                <span className="c0">
                    Deshalb erklären wir dir hier, wie wir mit deinen Daten umgehen, damit diese nur dann genutzt
                    werden, wenn dies unbedingt nötig ist. Und natürlich auch nur von denen, die es etwas angeht.{' '}
                </span>
            </p>
            <p className="c16">
                <span className="c0">
                    Nachfolgend findest du Informationen zu der Art und Weise, wie wir deine Daten verarbeiten und
                    schützen, sowie zu deinen Rechten im Kontext des Datenschutzes.
                    <br />
                    ___________________________________________________________________________________
                </span>
            </p>
            <p className="c8">
                <span className="c7 c21">
                    Wer für die Verarbeitung deiner personenbezogenen Daten verantwortlich ist
                </span>
            </p>
            <p className="c8 c10">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c0">Verantwortlich für die Verarbeitung deiner Daten sind wir, also die</span>
            </p>
            <p className="c8 c11">
                <span className="c4">
                    <br />
                    Wemolo GmbH
                    <br />
                    St.-Martin-Strasse 72
                    <br />
                    81541 München
                    <br />
                    Deutschland
                    <br />
                    Tel.: +49 (0) 89 356477 60
                    <br />
                </span>
                <span className="c9">
                    <a className="c13" href="mailto:help@wemolo.com">
                        help@wemolo.com
                    </a>
                </span>
                <span className="c12">&nbsp;</span>
                <span className="c4">
                    <br />
                </span>
                <span className="c9">
                    <a className="c13" href="https://www.wemolo.com">
                        www.wemolo.com
                    </a>
                </span>
                <span className="c12">&nbsp;</span>
            </p>
            <p className="c8 c10">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c0">in Zusammenarbeit mit unserem Datenschutzbeauftragten</span>
            </p>
            <p className="c8 c10">
                <span className="c0" />
            </p>
            <p className="c8 c11">
                <span className="c4">
                    Christian Schmoll
                    <br />
                    Kaiserplatz 2<br />
                    80803 München
                    <br />
                    Deutschland
                    <br />
                </span>
                <span className="c9 c14">
                    <a className="c13" href="mailto:schmoll@lucid-compliance.com">
                        schmoll@lucid-compliance.com
                    </a>
                </span>
            </p>
            <p className="c8 c10 c11">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c3 c7">Warum wir deine personenbezogenen Daten verarbeiten</span>
            </p>
            <p className="c8 c11 c10">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c0">
                    Deine Daten erheben wir insbesondere im Rahmen unseres Buchungsprozesses - also in sogenannten
                    vertraglichen und vorvertraglichen Beziehungen. Darüber hinaus können rechtliche Verpflichtungen
                    bestehen, beispielsweise die Rechnungsstellung. Dafür bitten wir dich um deine Zustimmung, die du
                    jederzeit folgendermaßen verwalten und widerrufen kannst.
                </span>
            </p>
            <p className="c8 c10">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c0">
                    Um die Buchung durchführen zu können, benötigen wir die folgenden personenbezogenen Informationen
                    von dir:
                </span>
            </p>
            <ul className="c6 lst-kix_6euado2a7fnu-0 start">
                <li className="c2 li-bullet-0">
                    <span className="c4">Kennzeichen,</span>
                </li>
                <li className="c2 li-bullet-0">
                    <span className="c0">E-Mail-Adresse,</span>
                </li>
                <li className="c2 li-bullet-0">
                    <span className="c0">Zahlungsmittel.</span>
                </li>
            </ul>
            <p className="c8 c10">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c0">
                    Dein Kennzeichen brauchen wir, um dich in unseren Systemen entsprechend deiner Buchung für den
                    Parkvorgang auf einem bestimmten Parkplatz zu berechtigen. Für deine Online Zahlung werden dann
                    sowohl deine E-Mail-Adresse als auch Details zu dem von dir ausgewählten Zahlungsmittel gebraucht.
                </span>
            </p>
            <p className="c8 c10">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c0">
                    Falls du die Vorteile nutzen möchtest, die ein Nutzerkonto auf unserer Buchungsplattform mit sich
                    bringt, benötigen wir zusätzlich zu den oben stehenden Daten deinen vollständigen Namen, also{' '}
                </span>
            </p>
            <ul className="c6 lst-kix_9vc03qu28znz-0 start">
                <li className="c2 li-bullet-0">
                    <span className="c0">Vorname,</span>
                </li>
                <li className="c2 li-bullet-0">
                    <span className="c0">Nachname. </span>
                </li>
            </ul>
            <p className="c8">
                <span className="c0">
                    Auf diese Weise können wir dich in allen Kontaktpunkten mit uns besser unterstützen.
                </span>
            </p>
            <p className="c8 c10">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c3 c7">Wie lange wir deine Daten aufbewahren</span>
            </p>
            <p className="c8 c10">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c0">
                    Diese Daten speichern wir solange sicher bei uns ab, bis der Zweck, zu dem wir deine Daten
                    benötigen, erfüllt ist. Buchungsdaten werden nach Ablauf der Regelverjährung gelöscht.
                    Rechnungsdaten werden gemäß der steuerrechtlichen Vorgaben für 10 Jahre aufbewahrt.{' '}
                </span>
            </p>
            <p className="c8 c10">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c3 c7">
                    Welche Recht du bezüglich der Verarbeitung deiner personenbezogenen Daten durch uns hast
                </span>
            </p>
            <p className="c8 c10">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c0">
                    Zuallererst kannst du natürlich entscheiden, uns keine deiner personenbezogenen Daten zur Verfügung
                    zu stellen. Bitte beachte, dass die Funktionen und Services unserer Plattform eingeschränkt sind,
                    falls die Nutzung personenbezogene Daten voraussetzt.
                </span>
            </p>
            <p className="c8 c10">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c0">
                    Wenn du dich entschieden hast, personenbezogene Daten mit uns zu teilen, hast du gemäß der DS-GVO
                    folgende Rechte, die du jederzeit ausüben kannst:{' '}
                </span>
            </p>
            <p className="c8 c10">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c3 c5">Recht auf Auskunft (gem. Art. 15 DS-GVO):</span>
                <span className="c0">
                    &nbsp;Du darfst jederzeit von uns eine Bestätigung verlangen, ob wir personenbezogene Daten, die
                    dich betreffen, von uns verarbeitet werden. Falls ja, geben wir dir jederzeit Auskunft über
                </span>
            </p>
            <ul className="c6 lst-kix_j25jahnvxxq5-0 start">
                <li className="c2 li-bullet-0">
                    <span className="c0">die Zwecke, zu denen wir deine personenbezogene Daten verarbeiten</span>
                </li>
                <li className="c2 li-bullet-0">
                    <span className="c0">die Kategorien von personenbezogenen Daten, die wir verarbeiten</span>
                </li>
                <li className="c2 li-bullet-0">
                    <span className="c0">
                        die (Kategorien von) Empfängern, gegenüber denen wir deine personenbezogenen Daten offengelegt
                        haben oder offenlegen werden
                    </span>
                </li>
                <li className="c2 li-bullet-0">
                    <span className="c0">
                        die konkrete geplante Speicherdauer deiner personenbezogenen Daten bzw. die Kriterien, die zur
                        Festlegung der Speicherdauer, herangezogen werden
                    </span>
                </li>
                <li className="c2 li-bullet-0">
                    <span className="c0">
                        eine eventuelle automatische Verarbeitung sowie ein eventuelles Profiling, das deine
                        personenbezogenen Daten durchlaufen, und welche Logik und potenzielle Konsequenzen dies umfassen
                        würde
                    </span>
                </li>
                <li className="c2 li-bullet-0">
                    <span className="c0">
                        die geltenden Schutzmaßnahmen, wenn Daten in eine Drittland oder an eine internationale
                        Organisation übertragen werden
                    </span>
                </li>
            </ul>
            <p className="c8 c10">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c3 c5">Recht auf Berichtigung (gem. Art. 16 DS-GVO):</span>
                <span className="c3">&nbsp;</span>
                <span className="c0">
                    Deine von unseren gespeicherten Daten sind fehlerhaft oder unvollständig? Diese müssen wir jederzeit
                    nach deinen Vorgaben berichtigen.
                </span>
            </p>
            <p className="c8 c10">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c3 c5">Recht auf Vergessen (gem. Art. 17 DS-GVO):</span>
                <span className="c3">&nbsp;</span>
                <span className="c0">
                    Es ist besser für uns getrennte Wege zu gehen? Du kannst jederzeit die unverzügliche Löschung deiner
                    personenbezogenen Daten einfordern, wenn einer der folgenden Gründe zutrifft:
                </span>
            </p>
            <ul className="c6 lst-kix_kp6udrh6klz6-0 start">
                <li className="c2 li-bullet-0">
                    <span className="c0">
                        Der Zweck, zu dem wir deine personenbezogenen Daten erhoben haben, ist entfallen
                    </span>
                </li>
                <li className="c2 li-bullet-0">
                    <span className="c0">
                        Du hast deine Einwilligung zur Datenverarbeitung widerrufen oder es besteht keine rechtliche
                        Grundlage mehr
                    </span>
                </li>
                <li className="c2 li-bullet-0">
                    <span className="c0">Du widersprichst der Verarbeitung deiner personenbezogenen Daten</span>
                </li>
                <li className="c2 li-bullet-0">
                    <span className="c0">
                        Wir oder ein Dritter hat einen Fehler gemacht und deine personenbezogenen Daten wurden leider
                        unrechtmäßig verarbeitet
                    </span>
                </li>
            </ul>
            <p className="c8 c10">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c3 c5">Recht auf Einschränkung der Verarbeitung (gem. Art. 18 DS-GVO):</span>
                <span className="c0">
                    &nbsp;Wenn du die Richtigkeit deiner Daten bestreitest oder die Daten für rechtliche Ansprüche
                    benötigst, darf du von uns verlangen die Verarbeitung deiner personenbezogenen Daten einzuschränken
                </span>
            </p>
            <p className="c8 c10">
                <span className="c3 c7" />
            </p>
            <p className="c8">
                <span className="c3 c5">Recht auf Datenübertragbarkeit (gem. Art. 20 DS-GVO):</span>
                <span className="c0">
                    &nbsp;Du hast das Recht, deine personenbezogenen Daten von uns in einem „strukturierten, gängigen
                    und maschinenlesbaren Format“ anzufordern. Das gilt für alle personenbezogenen Daten, die wir
                    basierend auf deiner Zustimmung und automatisch verarbeiten.
                </span>
            </p>
            <p className="c8">
                <span className="c4">
                    Nach Erhalt kannst du die Daten an eine andere Partei übertragen oder die direkte Übertragung von
                    unseren Systemen an die Systeme eines anderen Anbieters anfordern.
                </span>
            </p>
            <p className="c8 c10">
                <span className="c7 c15" />
            </p>
            <p className="c8">
                <span className="c3 c5">Recht auf Widerspruch (gem. Art. 22 DS-GVO):</span>
                <span className="c3">&nbsp;</span>
                <span className="c0">
                    Du kannst deine Einwilligung zur Verarbeitung deiner personenbezogenen Daten jederzeit widerrufen.
                </span>
            </p>
            <p className="c8 c10">
                <span className="c0" />
            </p>
            <p className="c8">
                <span className="c3 c5">Recht auf Beschwerde bei einer Aufsichtsbehörde (gem. Art. 77 DS-GVO):</span>
                <span className="c3">&nbsp;</span>
                <span className="c4">
                    Wir haben etwas falsch gemacht? Du kannst dich jederzeit an die zuständige Aufsichtsbehörde wenden!
                    Zuständig ist in der Regel die an deinem üblichen Aufenthaltsort, Arbeitsplatz oder unserem
                    Unternehmenssitz ansässige Aufsichtsbehörde.
                </span>
            </p>
            <p className="c10 c22">
                <span className="c17 c7" />
            </p>
        </>
    )
}

export default DataPolicyDE
